/**
 * 功能: 修改ocr识别的内容
 */
<template lang="pug">
  el-dialog(width="22%" style="left: -60%;" title="修改OCR文本" :visible.sync="innerVisible" append-to-body :modal="false" :close-on-press-escape="false" :close-on-click-modal="false")
    el-row(v-for="item, index in OCRJson" :key="index")
      el-col(:span="2")
        el-checkbox(style="margin-top: 6px" v-model="item.checked" @change="handleChange(index)")
      el-col(:span="20")
        el-input(v-model="item.text" :size="GLOBAL.SIZE_OF_INPUTBOX" @focus="isFocusInput(index, 'focus')" @blur="isFocusInput(index, 'blur')")
    el-row(type="flex" justify="end" style="margin-top: 20px")
      el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" @click="close") 关闭
      el-button(type="danger" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="deleteOcrText") 删除
      el-button(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="confirmOcrText") 确认

</template>

<script>
export default {
  name: 'EditOcrText',
  data () {
    return {
      innerVisible: false,
      OCRJson: []
    }
  },
  methods: {
    // 获取到数据后, 初始化到弹框
    show (OCRJson) {
      this.OCRJson = JSON.parse(JSON.stringify(OCRJson))
      this.innerVisible = true
    },

    // 关闭弹框
    close () {
      for (const item of this.OCRJson) {
        this.$set(item, 'checked', false)
        delete item.color
      }
      this.$emit('reDrawCanvas', this.OCRJson)
      this.innerVisible = false
    },

    // 如果数据被选中则绘制红框, 如果不选中, 则去除选中的状态
    isFocusInput (index, type = 'focus') {
      for (const item of this.OCRJson) {
        if (!item.checked && item.color) {
          delete item.color
        }
      }
      if (type === 'focus') this.OCRJson[index].color = 'red'
      this.$emit('reDrawCanvas', this.OCRJson)
    },

    // 改变当然ocr文本的选中状态
    handleChange (index) {
      const checked = this.OCRJson[index].checked
      const color = checked ? 'red' : '#409eff'
      this.OCRJson[index].color = color
      this.$emit('reDrawCanvas', this.OCRJson)
    },

    // 保存修改后的ocr文本
    confirmOcrText () {
      for (const item of this.OCRJson) {
        delete item.checked
        delete item.color
      }
      this.$emit('updateOcrText', this.OCRJson)
      this.$message({ type: 'success', message: '插入成功！' })
      this.close()
    },

    // 删除选中的ocr文本
    deleteOcrText () {
      const length = this.OCRJson.length
      this.OCRJson = this.OCRJson.filter(item => !item.checked)
      if (length === this.OCRJson.length) {
        return this.$message({ type: 'warning', message: '未选择任何目标！' })
      }
      for (const item of this.OCRJson) {
        this.$set(item, 'checked', false)
      }
      this.$emit('deleteOcrText', this.OCRJson)
      this.$message({ type: 'success', message: '删除成功！' })
      // this.close()
    }
  }
}
</script>

<style>

</style>
